import React from 'react';
import Registration from '../../Registration/Registration';


const Login = () => {
    return (
        <div>
            <h2>please Login:</h2>
            <Registration></Registration>

        </div>
    );
};

export default Login;